import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { Component } from 'react';
import shallowEqual from '../utils/shallowEqual';
import utils from './utils';
import { getLocale } from '../locale';
export default (function (Origin) {
  return (
    /*#__PURE__*/
    function (_Component) {
      _inherits(DatePickerValue, _Component);

      var _super = _createSuper2(DatePickerValue);

      function DatePickerValue(props) {
        var _this;

        _classCallCheck(this, DatePickerValue);

        _this = _super.call(this, props);
        _this.state = {
          value: props.value
        };
        _this.handleBlur = _this.handleBlur.bind(_assertThisInitialized(_this));
        _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
        _this.rangeWithSingle = _this.rangeWithSingle.bind(_assertThisInitialized(_this));
        return _this;
      }

      _createClass(DatePickerValue, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          this.convertValue(this.props.value);
        }
      }, {
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(nextProps, nextState) {
          var options = {
            deep: ['defaultValue', 'name', 'value']
          };
          return !(shallowEqual(nextProps, this.props, options) && shallowEqual(nextState, this.state, options));
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
          var value = this.props.value;

          if (!shallowEqual(prevProps.value, value) && !shallowEqual(value, this.state.value)) {
            this.convertValue(value);
          }
        }
      }, {
        key: "getOptions",
        value: function getOptions() {
          var timeZone = this.props.timeZone;
          return {
            timeZone: timeZone,
            weekStartsOn: getLocale('startOfWeek')
          };
        }
      }, {
        key: "getFormat",
        value: function getFormat() {
          var _this$props = this.props,
              format = _this$props.format,
              type = _this$props.type;
          if (format) return format;

          switch (type) {
            case 'datetime':
              return 'YYYY-MM-DD HH:mm:ss';

            case 'month':
              return 'YYYY-MM';

            case 'time':
              return 'HH:mm:ss';

            case 'week':
              return 'GGGG WW';

            default:
              return 'YYYY-MM-DD';
          }
        }
      }, {
        key: "rangeWithSingle",
        value: function rangeWithSingle() {
          if (!this.state.value) return false;
          return this.props.range && !this.props.allowSingle && Array.isArray(this.state.value) && this.state.value.filter(function (v) {
            return v;
          }).length === 1;
        }
      }, {
        key: "convertValue",
        value: function convertValue(value) {
          var _this2 = this;

          var _this$props2 = this.props,
              range = _this$props2.range,
              onChange = _this$props2.onChange;

          if (!value) {
            this.setState({
              value: value
            });
            return undefined;
          }

          var format = this.getFormat();

          if (!range) {
            var _newValue = utils.format(utils.toDateWithFormat(value, format, undefined, this.getOptions()), format, this.getOptions());

            if (_newValue !== value && onChange) onChange(_newValue);else if (_newValue !== this.state.value) this.setState({
              value: _newValue
            });
            return _newValue;
          } // expand


          var quickSelect = this.state.quickSelect;
          var newValue = value.map(function (v) {
            if (!v) return undefined;
            return utils.format(utils.toDateWithFormat(v, format, undefined, _this2.getOptions()), format, _this2.getOptions());
          });

          if (!shallowEqual(newValue, value)) {
            if (onChange) onChange(newValue, quickSelect);
          } else if (!shallowEqual(newValue, this.state.value)) {
            // reset quickSelect if newValue !== this.state.value
            this.setState({
              value: newValue,
              quickSelect: null
            });
            return newValue;
          }

          if (shallowEqual(newValue, [undefined, undefined])) {
            this.setState({
              value: newValue,
              quickSelect: null
            });
          } else {
            // @ts-ignore
            this.state.value = newValue;
          }

          return newValue;
        }
      }, {
        key: "handleChange",
        value: function handleChange(value, callback, quickSelect) {
          var range = this.props.range;
          var newState = {
            value: value
          };

          if (range) {
            newState.quickSelect = quickSelect;
          }

          this.setState(newState, callback);
        }
      }, {
        key: "handleBlur",
        value: function handleBlur() {
          var onChange = this.props.onChange;

          if (this.rangeWithSingle()) {
            this.setState({
              value: this.props.value
            });
          } else if (this.state.value !== this.props.value && onChange) onChange(this.state.value, this.state.quickSelect);
        }
      }, {
        key: "render",
        value: function render() {
          var value = this.state.value;
          return (
            /*#__PURE__*/
            React.createElement(Origin, Object.assign({}, this.props, {
              onChange: this.handleChange,
              onValueBlur: this.handleBlur,
              value: value
            }))
          );
        }
      }]);

      return DatePickerValue;
    }(Component)
  );
});